import React, { useEffect, useRef, useState } from "react";
import {
  Breadcrumb,
  Button,
  Container,
  Content,
  Header,
  IconButton,
} from "rsuite";
import "rsuite/dist/rsuite.min.css";
import { HeaderComponent } from "./header.component";
import AppSidebar from "./sidenavbar-menu";
import AppHeader from "./app.header.component";
import Dashboard from "../features/home/dashboard.page";
import ReportCenter from "../features/reports/report-center";
import MainGroupPage from "../features/maingroup/maingroup.page";
import SubGroupPage from "../features/subgroup/subgroup.page";
import CategoryPage from "../features/category/category.page";
import ZonePage from "../features/zone/zone.page";
import TalukPage from "../features/taluk/taluk.page";
import DistrictPage from "../features/district/district.page";
import CorporationZonePage from "../features/corporationzone/corporationzone.page";
import WardPage from "../features/ward/ward.page";
import StatePage from "../features/state/state.page";
import ConstituencyPage from "../features/constituency/constituency.page";
import RoutePage from "../features/route/route.page";
import RouteCityPage from "../features/routecity/routecity.page";
import UOMPage from "../features/uom/uom.page";
import ProductPage from "../features/product/product.page";
import ProductTaxPage from "../features/producttax/producttax.page";
import ProductAvailabilityPage from "../features/productavailability/productavailability.page";
import ProductPricePage from "../features/productprice/productprice.page";
import CustomerPage from "../features/customer/customer.page";
import AgentPage from "../features/agent/agent-page";
import DropingPointPage from "../features/dropingpoint/dropingpoint-page";
import EmployeePage from "../features/employee/employee-page";
import { ListConsumer } from "antd/es/list/context";
import VehiclePage from "../features/vehicle/vehicle.page";
import VehicleTypePage from "../features/vehicletype/vehicletype.page";
import VehicleTransportPage from "../features/vehicletransport/vehicletransport.page";
import AgentOrderPage from "../features/transaction/agent-order/agentorder.page";
import AgentLiterOrderPage from "../features/transaction/agent-literorder/agentliterorder.page";
import ProductInvoicePage from "../features/transaction/product-invoice/productinvoice.page";
import { PrepareIndentReport } from "../features/reports/indent/prepareindent-report";
import FermentedMilk from "../features/home/fermentedmilk";
import EmployeeFreeMilkPage from "../features/transaction/employeefreemilk/employeefreemilk.page";
import { SideBarHeaderComponent } from "./sidenavbar.menu.header";
import MenuIcon from "@rsuite/icons/Menu";
import PaymentGatewayPage from "../features/paymentgateway/paymentgateway.page";
import { string } from "yup";
import { buildBreadcrumbs } from "./sidenavbar-buildBreadcrumbs";
import { BreadcrumDisplay } from "./sidenavbar-breadcrum";
import BlockPage from "../features/block/block.page";
import CounterPage from "../features/counter/counter.page";
import UnionsPage from "../features/unions/unions.page";
import CardCustomerPage from "../features/cardcustomer/cardcustomer-page";
import CardOrderEntryPage from "../features/transaction/card-order/cardorder-entry";
import CardOrderPage from "../features/transaction/card-order/cardorder.page";
import PurchasePage from "../features/transaction/purchase/purchase.page";
import { useAuth } from "react-oidc-context";
import { Dispatch } from "../features/transaction/dispatch/dispatch.page";


const SideBarMainComponent: React.FC = () => {
  const refLastActivePage = useRef<string>("");
  const refBreadCrum = useRef<string[]>([]);
  const auth = useAuth();

  // const [activePage, setActivePage] = useState<string>(() => {
  //   const userType = localStorage.getItem("userType");
  //   if (userType === "Web") {
  //     return "dashboard";
  //   } else {
  //     return "agentorder";
  //   }

const userType = auth.user.profile?.['custom:userType'];
const [activePage, setActivePage] = useState<string>(() => {
    console.log("userType1:", userType);
    if (userType === "web") {
      return "dashboard";
    } else {
      return "agentorder";
    }
  });

  useEffect(() => {
    renderPage();
  }, [refLastActivePage.current, activePage]);


  const renderPage = () => {
    if (activePage === undefined) {
      setActivePage(refLastActivePage.current);
      refBreadCrum.current = buildBreadcrumbs(activePage); // from your activePage state
      return;
    }
    refLastActivePage.current = activePage;
    refBreadCrum.current = buildBreadcrumbs(activePage); // from your activePage state

    switch (activePage) {
      case "dashboard":
        return <Dashboard />;
      case "report-center":
        return <ReportCenter />;
      case "payment-gateway":
        return <PaymentGatewayPage />;

      case "zone":
        return <ZonePage />;
      case "taluk":
        return <TalukPage />;
      case "district":
        return <DistrictPage />;
      case "block":
        return <BlockPage />;
      case "counter":
        return <CounterPage />;
      case "corporate-zone":
        return <CorporationZonePage />;
      case "ward":
        return <WardPage />;
      case "state":
        return <StatePage />;
      case "constituency":
        return <ConstituencyPage />;
      case "union":
        return <UnionsPage />;

      case "route":
        return <RoutePage />;
      case "routecity":
        return <RouteCityPage />;

      // Products
      case "main-group":
        return <MainGroupPage />;
      case "sub-group":
        return <SubGroupPage />;
      case "category":
        return <CategoryPage />;
      case "uom":
        return <UOMPage />;
      case "product":
        return <ProductPage />;
      case "producttax":
        return <ProductTaxPage />;
      case "productavailability":
        return <ProductAvailabilityPage />;
      case "productprice":
        return <ProductPricePage />;

      //Party
      case "agent":
        return <AgentPage />;
      case "droppingpoint":
        return <DropingPointPage />;
      case "customer":
        return <CustomerPage />;
      case "consumer":
        return <CardCustomerPage />;
      case "employee":
        return <EmployeePage />;

      //Vehicles
      case "vehiclesetup":
        return <VehiclePage />;
      case "vehicletype":
        return <VehicleTypePage />;
      case "transport":
        return <VehicleTransportPage />;

      //Sales
      case "agentorder":
        return <AgentOrderPage />;
      case "agentorderliter":
        return <AgentLiterOrderPage />;
      case "consumerorder":
        return <CardOrderPage />;
      case "productinvoice":
        return <ProductInvoicePage />;
      case "prepareindent":
        return <PrepareIndentReport />;
      case "employeefreemilk":
        return <EmployeeFreeMilkPage />;
      case "purchase":
        return <PurchasePage />;

     case "dispatch":
        return <Dispatch />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <Container style={{ height: "100vh" }}>
      <SideBarHeaderComponent />
      <Container>
        <AppSidebar
          onSelect={(key) => setActivePage(key as string)}
          activePage={activePage}
        />
        <Content className="card" style={{}}>
          <div className="d-flex  mt-1">
            <BreadcrumDisplay activePage={activePage}></BreadcrumDisplay>
          </div>
          {renderPage()}
        </Content>
      </Container>
    </Container>
  );
};

export default SideBarMainComponent;
